import { PermissionsService } from './../../../core/services/permissions/permissions.service';
import { CartService } from './../../../core/services/cart/cart.service';
import { CommonModule, registerLocaleData } from '@angular/common';
import { Component, LOCALE_ID, OnInit } from '@angular/core';
import {
  MatDialog,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { Resident } from '../../models/resident.model';
import { MatTableModule } from '@angular/material/table';
import { CartProduct } from '../../models/cart.model';
import { SlideToggleComponent } from '../slide-toggle/slide-toggle.component';
import { CartProductsTableComponent } from '../cart-products-table/cart-products-table.component';
import { ProfileAvatarComponent } from '../profile-avatar/profile-avatar.component';
import { InfoBoxComponent } from '../info-box/info-box.component';
import { TranslateService } from '@ngx-translate/core';
import * as de from '@angular/common/locales/de';
import { ModalCloseButtonComponent } from '../modal-close-button/modal-close-button.component';
import { ConfirmationModalComponent } from '../confirmation-modal/confirmation-modal.component';
import { DepartmentWithResidents } from '../../models/department.model';
import { EmptyListInfoComponent } from '../empty-list-info/empty-list-info.component';
import { ShopSelectionStore } from '../../../core/state/shop-selection.store';

@Component({
  selector: 'app-cart-modal',
  templateUrl: './cart-modal.component.html',
  styleUrls: ['./cart-modal.component.scss'],
  imports: [
    MatDialogModule,
    MatIconModule,
    CommonModule,
    CartProductsTableComponent,
    ProfileAvatarComponent,
    InfoBoxComponent,
    ModalCloseButtonComponent,
    EmptyListInfoComponent,
  ],
  providers: [
    {
      provide: LOCALE_ID,
      useValue: 'de-DE',
    },
  ],
})
export class CartModalComponent implements OnInit {
  selectedResident: Resident = null;
  products: CartProduct[] = [];
  selectedDepartment: DepartmentWithResidents;

  constructor(
    private shopSelectionStore: ShopSelectionStore,
    private translateService: TranslateService,
    private dialogRef: MatDialogRef<CartModalComponent>,
    private cartService: CartService,
    private dialog: MatDialog,
    public permissionsService: PermissionsService
  ) {
    registerLocaleData(de.default);
  }

  get residentCart() {
    return this.cartService.cart.getResidentCart(this.selectedResident.id);
  }
  get cartProducts() {
    return this.residentCart?.products ?? [];
  }

  get cartItemsCount() {
    return this.residentCart?.getTotalItemsCount ?? 0;
  }

  get cartTotal() {
    return this.residentCart?.total ?? 0;
  }

  get noProductsText() {
    return this.translateService.instant('cartModal.noProducts');
  }

  get selectedResidentName() {
    if (this.selectedDepartment?.isB2B) {
      return `${this.selectedDepartment?.name} (B2B)`;
    }
    return `${this.selectedResident?.fname} ${this.selectedResident?.lname}`;
  }

  get selectedResidentImage() {
    if (this.selectedDepartment?.isB2B) {
      return this.selectedDepartment?.iconUrl;
    }
    return this.selectedResident?.image;
  }

  ngOnInit(): void {
    this.shopSelectionStore.resident$.subscribe(resident => {
      this.selectedResident = resident;
    });
    this.shopSelectionStore.department$.subscribe(department => {
      this.selectedDepartment = department;
    });
    this.products = this.cartProducts;
  }

  onSliderClick() {
    console.log('check bag');
  }

  showEmptyCartConfirmation() {
    const dialogRef = this.dialog.open(ConfirmationModalComponent, {
      width: 'auto',
      maxWidth: '540px',
      autoFocus: false,
      data: {
        message: `Sind Sie sicher, dass Sie den gesamten Warenkorb für ${this.selectedResidentName} löschen möchten?`,
        closable: true,
        buttons: [
          { text: 'Abbrechen', id: 0, closeDialog: true, color: '#42405F' },
          {
            text: 'Ja, löschen',
            id: 1,
            action: this.emptyCart.bind(this),
            color: '#ff6100',
          },
        ],
      },
    });
  }

  emptyCart() {
    this.cartService.setUpdate();
    this.cartService.cart.emptyResidentCart(this.selectedResident.id);
  }

  closeDialog(): void {
    this.dialogRef.close();
  }
}
